export const T = {
  en_GB: {
    admin: "Admin",
    title: "Component Usage",
    description: "How many flow definitions and PDF templates use each component.",
    component: "Component",
    flows: "Flows",
    pdfTemplates: "PDF templates",
    noData: "No component usage found.",
    loadError: "Failed to load component usage.",
  },
  nb_NO: {
    admin: "Admin",
    title: "Komponentbruk",
    description: "Hvor mange flytdefinisjoner og PDF-maler som bruker hver komponent.",
    component: "Komponent",
    flows: "Flyter",
    pdfTemplates: "PDF-maler",
    noData: "Ingen komponentbruk funnet.",
    loadError: "Kunne ikke laste komponentbruk.",
  },
} as const;
